import { ApiBaseService, ApiV2Service } from './api.base.service';
import store from '@/store/store';
import { ImportLocationsResponse, Job } from '../types';

export class JobsService {
  private apiV2: ApiBaseService;

  constructor() {
    this.apiV2 = ApiV2Service;
  }

  public async createJob(file: Blob, data: {[key: string]: string | number}, type: string, params: any = {}): Promise<Job> {
    const organisation = store.getters.activeOrganisation[0].id;
    let uri = `organisation/${organisation}/${type}/import?`;
    for ( const k of Object.keys(params) ) {
      uri = uri + `${k}=${params[k]}&`;
    }
    const { job_id, uploadData } = await this.apiV2.get<ImportLocationsResponse>(uri);

    const updatedJob = await this.apiV2.put<Job>(`organisation/${organisation}/jobs/${job_id}`, data);

    const formData = new FormData();
    Object.entries(uploadData.fields).forEach(([k, v]) => {
      formData.append(k, (v as string));
    });
    formData.append('file', file);
    await this.apiV2.postFormExt(uploadData.url, formData);

    return updatedJob;
  }

  public async getJobs(): Promise<Job[]> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.get(`organisation/${organisation}/jobs`);
  }

  public async pollJob(jobId: string): Promise<Job> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.get(`organisation/${organisation}/jobs/${jobId}`);
  }

  public async getAccountJobs(accountId: number): Promise<Job[]> {
    return this.apiV2.get(`accounts/${accountId}/jobs`);
  }

  public async pollAccountJob(accountId: number, jobId: string): Promise<Job> {
    return this.apiV2.get(`accounts/${accountId}/jobs/${jobId}`);
  }

  public async getAdminJobs(): Promise<Job[]> {
    return this.apiV2.get(`admin/jobs`);
  }

  public async pollAdminJob(jobId: string): Promise<Job> {
    return this.apiV2.get(`admin/jobs/${jobId}`);
  }
}
export default new JobsService();
